import 'css-chunksrc/client/scenes/workloads/detailsView/styles.scss';export default {
  "detailsViewToggle": "_detailsViewToggle_t6voc_1",
  "action": "_action_t6voc_10",
  "text": "_text_t6voc_23",
  "icon": "_icon_t6voc_30",
  "details": "_details_t6voc_1",
  "detail": "_detail_t6voc_1"
};